export default {
  // 视频详情的style.js
  img_effects: {
    id: 1,
    formData: {
      effect: 0,//当前选中的特效
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        },
        custom: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        }
      },
      background: {
        radio_val: 'default',
        default: {
          color: "rgba(255, 255, 255, 0)",
        },
        custom: {
          color: "rgba(255, 255, 255, 1)",
        }
      },
      direction: 'left'
    }
  },
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_widgets_infor: {
    shareType: ['weixin', 'qq', 'weibo'],
    enShareType: ['twitter','skype','wechat','facebook','linkedin'],
    share: 'open', // open closed
    shareDisplayStyle: 'default',
    firstAndNextShow: 'true',
    recommendationOption: 'system',
    //每行个数
    col_num: {
      radio_val: 'default',
      default: {
        value: 5,
      },
      custom: {
        value: 5,
      }
    },
    //图片缩放
    backgroundSize: {
      radio_val: 'default',
      default: {
        backgroundSize: 'cover'
      },
      custom: {
        backgroundSize: 'auto'
      }
    },
    // 图片大小
    pic_size: {
      radio_val: 'default',
      default: {
        width: '20%',
        height: '20%'
      },
      custom: {
        width: '20%',
        height: '20%'
      }
    },
    //每行间距
    padding: {
      radio_val: 'default',
      default: {
        paddingTop: 20,
        paddingLeft: 20,
      },
      custom: {
        paddingTop: 20,
        paddingLeft: 20,
      }
    },
    //图片高度
    img_size: {
      radio_val: 'default',
      default: {
        width: '100%',
        height: '90%',
      },
      custom: {
        width: '100%',
        height: '90%',
      }
    },
    recommend_video_num: 10,
  },
  mb_widgets_infor: {
    //每行个数
    col_num: {
      radio_val: 'default',
      default: {
        value: 2,
      },
      custom: {
        value: 2,
      }
    },
    recommend_video_num: 4
  },
  listArr: {
    module_style: 0,
    download: 'block', // 下载
    recommend: 'block', // 相关推荐
    play_count: 'block',
    articleList: []
  }
}


// WEBPACK FOOTER //
// ./src/widgets/basic_video_detail/style.js